import styled from "@emotion/styled"
import Link from "components/Link"

const ArticleAsideBlogPostLink = styled(Link)`
  font-weight: 500;
  color: ${({ theme }) => theme.palette.primary.main};
  text-decoration: none;
  display: flex;
  gap: 10px;
  align-items: center;
  font-size: 18px;
  border-bottom: 1px solid transparent;
  transition: all 0.2s;
  margin-bottom: -1px;
  max-width: max-content;
  width: 100%;

  &:hover {
    border-color: ${({ theme }) => theme.palette.primary.main};
  }
`

export default ArticleAsideBlogPostLink
